<template>
    <el-dialog title="Plus de stock" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formOutOfStock" ref="form" :model="form">
            <el-form-item prop="out_of_stock_message">
                <el-input placeholder="Message" v-model="form.out_of_stock_message"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                out_of_stock_message: null
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                datas: this.form,
                mode: 'out_of_stock'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
